export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-accent-50/60 via-background-50 to-primary-50/30"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-5">
              每日更新 · 全站免费
            </span>
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight">
              窝窝影院
              <br className="hidden sm:block" />
              免费高清追剧首选
            </h1>
            <p className="mt-4 text-lg md:text-xl text-accent-600 font-heading">
              海量剧集 即刻畅享 追你所爱
            </p>
            <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0">
              窝窝影院汇聚全网最新最全电视剧资源，涵盖国产剧、韩剧、美剧、日剧、泰剧等全品类内容。
              每日同步更新热播剧集，超清画质流畅不卡顿，全程无广告打扰，让你追剧追到停不下来。
              无论你是悬疑烧脑迷、甜宠恋爱控还是古装历史粉，这里都有你爱看的好剧。
            </p>

            <div className="mt-6 flex flex-wrap items-center justify-center lg:justify-start gap-6 text-sm text-foreground-500">
              <div className="flex items-center gap-1.5">
                <span className="w-2 h-2 rounded-full bg-green-500"></span>
                <span>每日更新 200+ 剧集</span>
              </div>
              <div className="flex items-center gap-1.5">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                <span>覆盖 15+ 国家地区</span>
              </div>
              <div className="flex items-center gap-1.5">
                <span className="w-2 h-2 rounded-full bg-primary-500"></span>
                <span>1080P 超清画质</span>
              </div>
            </div>

            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-full hover:bg-primary-600 transition-colors cursor-pointer text-sm"
              >
                <i className="ri-fire-line"></i>
                查看热播榜单
              </a>
              <a
                href="#cards"
                className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3 border border-foreground-200 text-foreground-700 font-medium rounded-full hover:bg-background-100 transition-colors cursor-pointer text-sm"
              >
                <i className="ri-play-circle-line"></i>
                浏览精选剧集
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-[300px] h-[400px] md:w-[380px] md:h-[500px] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20cinematic%20scene%20with%20modern%20living%20room%20and%20large%20TV%20screen%20displaying%20colorful%20movie%20posters%2C%20cozy%20ambient%20lighting%20with%20warm%20orange%20and%20golden%20tones%2C%20comfortable%20sofa%20with%20blanket%2C%20popcorn%20bowl%20on%20coffee%20table%2C%20evening%20atmosphere%2C%20cinematic%20photography%20style%20with%20soft%20glow%2C%20immersive%20home%20theater%20experience%2C%20rich%20textures%2C%20inviting%20and%20warm%20composition&width=760&height=1000&seq=hero-cinema-2026&orientation=portrait"
                alt="窝窝影院追剧场景"
                className="w-full h-full object-cover"
                title="窝窝影院 - 免费高清追剧体验"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}